import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import hasProperty from "lodash/has";
import Layout from "layouts/DashboardManage";
import { addRole } from "store/actions/roleAction";
import { notifyApiError } from "components/Notification";
import SubmitButton from "components/Forms/Buttons/Submit";
import Textbox from "components/Forms/Elements/Textbox";
import Translate from "helpers/Translate";

export class Add extends Component {
  state = {
    name: "",
    enabledRoleType: "web",
    desktopPermissions: {
      login_desktop: false,
      submit_review: false,
      bulk_submit_review: false,
      access_own_accuracy_report: false,
      false_reject: false,
      add_comments: false,
      upload_docs_to_cloud: false,
      use_lens_ai: false
    },
    webPermissions: {
      login_web: false,
      submit_review: false,
      bulk_submit_review: false,
      access_accuracy_report: false,
      access_own_accuracy_report: false,
      false_reject: false,
      add_comments: false,
      reject: false,
      manage_clients: false,
      manage_workflows: false,
      manage_meta_data: false,
      manage_departments: false,
      manage_roles: false,
      manage_users: false,
      manage_teams: false,
      upload_docs_to_cloud: false,
      upload_docs_to_adapter: false,
      approve: false,
      bulk_approve: false,
      manage_file_history: false,
      manage_deleted_file: false,
      manage_ai: false
    }
  };

  componentDidUpdate(prevProps) {
    // When the new role is created successfully, we will redirect to step 2
    if (
      prevProps.addRoleResponse !== this.props.addRoleResponse &&
      hasProperty(this, "props.addRoleResponse.id")
    ) {
      // Redirect to manage page
      this.props.history.push(`/manage/roles`);
    }

    // When there was a problem creating the new role
    if (
      prevProps.errorRole !== this.props.errorRole &&
      this.props.errorRole &&
      Object.keys(this.props.errorRole).length > 0
    ) {
      notifyApiError(this.props.errorRole);
    }
  }

  handleChange = e => {
    e.persist();

    // If the role name was changed
    if ("name" in e.target && e.target.name === "name") {
      this.setState({
        name: e.target.value
      });
    } else {
      const roleType = e.target.getAttribute("roletype");
      let permissionType = "webPermissions";
      if (roleType === "desktop") {
        permissionType = "desktopPermissions";
      }

      this.setState({
        [permissionType]: {
          ...this.state[permissionType],
          [e.target.id]: e.target.checked
        }
      });
    }
  };

  selectDesktopPermissions = roleType => {
    const webPermissions = {};
    for (const key in this.state.webPermissions) {
      if (this.state.webPermissions.hasOwnProperty(key)) {
        webPermissions[key] = false;
      }
    }
    this.setState({
      webPermissions,
      enabledRoleType: roleType
    });
  };

  selectWebPermissions = roleType => {
    const desktopPermissions = {};
    for (const key in this.state.desktopPermissions) {
      if (this.state.desktopPermissions.hasOwnProperty(key)) {
        desktopPermissions[key] = false;
      }
    }
    this.setState({
      desktopPermissions,
      enabledRoleType: roleType
    });
  };

  selectAllPermissions = (e, roleType) => {
    // desktop permissions
    if (roleType === "desktop") {
      const desktopPermissions = {};
      for (const key in this.state.desktopPermissions) {
        if (this.state.desktopPermissions.hasOwnProperty(key)) {
          desktopPermissions[key] = e.target.checked;
        }
      }

      this.setState({
        desktopPermissions
      });
    }

    // web permissions
    if (roleType === "web") {
      const webPermissions = {};
      for (const key in this.state.webPermissions) {
        if (this.state.webPermissions.hasOwnProperty(key)) {
          webPermissions[key] = e.target.checked;
        }
      }

      this.setState({
        webPermissions
      });
    }
  };

  handleCreate = () => {
    const permissions = [];
    for (const key in this.state.desktopPermissions) {
      if (this.state.desktopPermissions.hasOwnProperty(key)) {
        const isChecked = this.state.desktopPermissions[key];
        if (isChecked) {
          permissions.push(key);
        }
      }
    }

    for (const key in this.state.webPermissions) {
      if (this.state.webPermissions.hasOwnProperty(key)) {
        const isChecked = this.state.webPermissions[key];
        if (isChecked) {
          permissions.push(key);
        }
      }
    }

    this.props.addRole({
      name: this.state.name,
      enabled_role_type: this.state.enabledRoleType,
      permissions
    });
  };

  render() {
    return (
      <Layout>
        <div className="add-edit-role">
          <h1 className="title mb-30">
            {Translate({ id: "add_roles_and_permissions" })}{" "}
          </h1>

          <div className="content mt-50">
            <div className="name-wrapper">
              <label htmlFor="name">{Translate({ id: "role_name" })} :</label>
              <Textbox
                type="text"
                placeholder={Translate({ id: "manager" })}
                id="name"
                name="name"
                fieldValue={this.state.name}
                onChange={this.handleChange}
                onReturnKey={this.handleCreate}
                errors={this.props.errorRole}
                errorKey="name"
                formErrorClass="form-error"
              />
            </div>

            <div className="user-type-option my-40">
              {/* <!-- Desktop User --> */}
              <div className="user-type-wrapper desktop-user-wrapper">
                <div className="permissions mt-101">
                  <div className="form-group my-10">
                    <label className="title mb-10">
                      <input
                        type="radio"
                        name="role_type"
                        checked={this.state.enabledRoleType === "desktop"}
                        onChange={() => {
                          this.selectDesktopPermissions("desktop");
                        }}
                      />{" "}
                      {Translate({
                        id: "id_like_to_set_permission_for_desktop_app"
                      })}
                    </label>
                    <div className="form-input-vgroup">
                      <label className="input-item my-5">
                        {" "}
                        <input
                          type="checkbox"
                          className="form-input"
                          name="selectall"
                          disabled={this.state.enabledRoleType !== "desktop"}
                          onChange={e =>
                            this.selectAllPermissions(e, "desktop")
                          }
                        />{" "}
                        <strong className="select-all">
                          {Translate({ id: "select_all" })}{" "}
                        </strong>
                      </label>
                      <label className="input-item my-5">
                        {" "}
                        <input
                          type="checkbox"
                          className="form-input"
                          id="login_desktop"
                          checked={this.state.desktopPermissions.login_desktop}
                          roletype="desktop"
                          disabled={this.state.enabledRoleType !== "desktop"}
                          onChange={this.handleChange}
                        />{" "}
                        {Translate({ id: "can_login_to_desktop_app" })}
                      </label>
                      <label className="input-item my-5">
                        {" "}
                        <input
                          type="checkbox"
                          className="form-input"
                          id="upload_docs_to_cloud"
                          checked={
                            this.state.desktopPermissions.upload_docs_to_cloud
                          }
                          roletype="desktop"
                          disabled={this.state.enabledRoleType !== "desktop"}
                          onChange={this.handleChange}
                        />{" "}
                        {Translate({ id: "can_upload_documents_to_cloud" })}
                      </label>
                      <label className="input-item my-5">
                        {" "}
                        <input
                          type="checkbox"
                          className="form-input"
                          id="submit_review"
                          checked={this.state.desktopPermissions.submit_review}
                          roletype="desktop"
                          disabled={this.state.enabledRoleType !== "desktop"}
                          onChange={this.handleChange}
                        />{" "}
                        {Translate({ id: "can_submit_for_review" })}
                      </label>
                      <label className="input-item my-5 hide">
                        {" "}
                        <input
                          type="checkbox"
                          className="form-input"
                          id="bulk_submit_review"
                          checked={
                            this.state.desktopPermissions.bulk_submit_review
                          }
                          roletype="desktop"
                          disabled={this.state.enabledRoleType !== "desktop"}
                          onChange={this.handleChange}
                        />{" "}
                        {Translate({ id: "can_bulk_submit_for_review" })}
                      </label>
                      <label className="input-item my-5">
                        {" "}
                        <input
                          type="checkbox"
                          className="form-input"
                          id="access_own_accuracy_report"
                          checked={
                            this.state.desktopPermissions
                              .access_own_accuracy_report
                          }
                          roletype="desktop"
                          disabled={this.state.enabledRoleType !== "desktop"}
                          onChange={this.handleChange}
                        />{" "}
                        {Translate({ id: "can_see_their_own_accuracy_report" })}
                      </label>
                      <label className="input-item my-5">
                        {" "}
                        <input
                          type="checkbox"
                          className="form-input"
                          id="false_reject"
                          checked={this.state.desktopPermissions.false_reject}
                          roletype="desktop"
                          disabled={this.state.enabledRoleType !== "desktop"}
                          onChange={this.handleChange}
                        />{" "}
                        {Translate({ id: "can_false_reject" })}
                      </label>
                      <label className="input-item my-5">
                        {" "}
                        <input
                          type="checkbox"
                          className="form-input"
                          id="add_comments"
                          checked={this.state.desktopPermissions.add_comments}
                          roletype="desktop"
                          disabled={this.state.enabledRoleType !== "desktop"}
                          onChange={this.handleChange}
                        />{" "}
                        {Translate({ id: "can_add_comments" })}
                      </label>
                      <label className="input-item my-5">
                        {" "}
                        <input
                          type="checkbox"
                          className="form-input"
                          id="use_lens_ai"
                          checked={this.state.desktopPermissions.use_lens_ai}
                          roletype="desktop"
                          disabled={this.state.enabledRoleType !== "desktop"}
                          onChange={this.handleChange}
                        />{" "}
                        {Translate({ id: "can_use_lens_ai" })}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Web User --> */}
              <div className="user-type-wrapper web-user-wrapper">
                <div className="permissions">
                  <div className="form-group my-10">
                    <label className="title mb-10">
                      <input
                        type="radio"
                        name="role_type"
                        checked={this.state.enabledRoleType === "web"}
                        onChange={() => this.selectWebPermissions("web")}
                      />{" "}
                      {Translate({
                        id: "id_like_to_set_permission_for_web_console"
                      })}
                    </label>

                    <div className="form-input-vgroup">
                      <div className="col-1">
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            name="selectall"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={e => this.selectAllPermissions(e, "web")}
                          />{" "}
                          <strong className="select-all">
                            {Translate({ id: "select_all" })}{" "}
                          </strong>
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="login_web"
                            checked={this.state.webPermissions.login_web}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_login_to_web_console" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="submit_review"
                            checked={this.state.webPermissions.submit_review}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_submit_for_review" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="bulk_submit_review"
                            checked={
                              this.state.webPermissions.bulk_submit_review
                            }
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_bulk_submit_for_review" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="access_own_accuracy_report"
                            checked={
                              this.state.webPermissions
                                .access_own_accuracy_report
                            }
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({
                            id: "can_see_their_own_accuracy_report"
                          })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="access_accuracy_report"
                            checked={
                              this.state.webPermissions.access_accuracy_report
                            }
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_see_others_accuracy_report" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="reject"
                            checked={this.state.webPermissions.reject}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_reject" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="false_reject"
                            checked={this.state.webPermissions.false_reject}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_false_reject" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="add_comments"
                            checked={this.state.webPermissions.add_comments}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_add_comments" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="manage_clients"
                            checked={this.state.webPermissions.manage_clients}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_manage_client" })}
                        </label>
                      </div>

                      <div className="col-2 mt-30">
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="manage_workflows"
                            checked={this.state.webPermissions.manage_workflows}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_manage_workflows" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="manage_users"
                            checked={this.state.webPermissions.manage_users}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_manage_users" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="manage_meta_data"
                            checked={this.state.webPermissions.manage_meta_data}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_manage_meta_data" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="manage_departments"
                            checked={
                              this.state.webPermissions.manage_departments
                            }
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_manage_collections" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="manage_roles"
                            checked={this.state.webPermissions.manage_roles}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_manage_role" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="approve"
                            checked={this.state.webPermissions.approve}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_approve" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="bulk_approve"
                            checked={this.state.webPermissions.bulk_approve}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_bulk_approve" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="manage_file_history"
                            checked={
                              this.state.webPermissions.manage_file_history
                            }
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "file_history" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="manage_deleted_file"
                            checked={
                              this.state.webPermissions.manage_deleted_file
                            }
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_view_deleted_file_logs" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="manage_ai"
                            checked={this.state.webPermissions.manage_ai}
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_manage_ai_credentials" })}
                        </label>
                        <label className="input-item my-5">
                          {" "}
                          <input
                            type="checkbox"
                            className="form-input"
                            id="upload_docs_to_adapter"
                            checked={
                              this.state.webPermissions.upload_docs_to_adapter
                            }
                            roletype="web"
                            disabled={this.state.enabledRoleType !== "web"}
                            onChange={this.handleChange}
                          />{" "}
                          {Translate({ id: "can_upload_documents_to_adapter" })}
                          <i
                            className="fas fa-info-circle ml-10"
                            data-tip={Translate({
                              id: "this_option_will_treat_the_user_as_the_last_user_in_the_workflow"
                            })}
                          ></i>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="save-cancel-buttons">
            <Link
              to="/manage/roles"
              className="btn manage-btn-cancel"
            >
              <i className="far fa-times-circle mr-10"></i>
              {Translate({ id: "cancel" })}
            </Link>

            <SubmitButton
              className="btn btn-primary manage-btn-save"
              buttonIconClass="fas fa-save mr-10"
              buttonText={Translate({ id: "save_changes" })}
              btnId="create"
              isLoading={this.props.isLoading}
              handleSubmit={this.handleCreate}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

Add.propTypes = {
  addRole: PropTypes.func.isRequired,
  addRoleResponse: PropTypes.object,
  errorRole: PropTypes.object,
  isLoading: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    addRoleResponse: state.role.addRole,
    errorRole: state.role.errorRole,
    isLoading: state.role.isLoadingRole
  };
};

export default connect(mapStateToProps, { addRole })(Add);
